export default function getAnimalStatusColor(
  belongs: boolean,
  state: string,
  gender: string,
) {
  if (state === 'ativo') {
    if (!belongs) {
      return '#FFA800';
    }

    if (gender === 'macho') {
      return '#004EA9';
    } else if (gender === 'femea') {
      return '#0075ff';
    }
  } else if (state === undefined) {
    return '#999999';
  } else {
    return '#DF3030';
  }
}
